















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class ElError extends Vue {
  @Prop() readonly error!: Error;
}
